import { Component, OnInit, ChangeDetectorRef, ElementRef, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { MenuAsideService } from 'src/app/core/_base/layout/services/menu-aside.service';
import { MenuHorizontalService } from 'src/app/core/_base/layout/services/menu-horizontal.service';
import { UtilsService } from 'src/app/Services/utils.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthApiService } from 'src/app/Services/auth.service';
import { AuthNoticeService } from '../auth-notice/auth-notice.service';
import { LayoutConfigService, SplashScreenService } from 'src/app/core/_base/layout';
import { FeeApiService } from 'src/app/Services/fee.service';

declare var $: any;

@Component({
  selector: 'app-signIn',
  templateUrl: './signIn.component.html',
  styleUrls: ['./signIn.component.scss']
})
export class SignInComponent implements OnInit {
  loginForm: FormGroup;
  loading = false;
  isLoggedIn$: Observable<boolean>;
  errorMessage: string;
  HarError: boolean = false;
  browserDomain
  logo: any;
  logoFlag: boolean = false;
  today: number = Date.now();
  headerLogo: string;
  entity: any = {};
  copyrightName: any = 'Loading';
  displayLogo = '' //./../../../../assets/images/fluidLoader.gif'
  displayDescription: string = 'Loading...';
  displayName: string = 'Loading';
  privacyPolicyUrl: string = '';
  tncUrl: string = '';
  disclaimerUrl: string = '';
  privacyPolicyFlag: boolean;
  tncFlag: boolean;
  disclaimerFlag: boolean;
  otpFlag: boolean = true;
  otpInputFlag: boolean;
  timerValue: number;
  showCallButton: boolean = false;
  year = new Date()
  constructor(private el: ElementRef, private render: Renderer2, private layoutConfigService: LayoutConfigService,
    private splashScreenService: SplashScreenService, private util: UtilsService, private api: AuthApiService, private menuAside: MenuAsideService,
    private menuHorizontal: MenuHorizontalService, private ref: ChangeDetectorRef, private route: ActivatedRoute,
    private fb: FormBuilder, private authNoticeService: AuthNoticeService, private router: Router, private feeService: FeeApiService) {

  }


  ngOnInit() {
    this.headerLogo = this.layoutConfigService.getLogo();
    this.setWhiteLabelling();
    this.splashScreenService.hide();
    this.openEntityList();
    this.validateForm()
    this.browserDomain = this.api.browserDomain;

    let qac = this.route.snapshot.paramMap.get('qac');
    if (qac != 'login') {
      this.api.getEntityByQac(qac)
        .subscribe(res => {
          this.entity = res;
          if (this.entity.bannerImages && Array.isArray(this.entity.bannerImages)) {
            this.entity.bannerImages = this.entity.bannerImages.map(img => {
              if (typeof img === 'string') {
                return { url: img, text: '', description: '' };
              }
              const parts = (img.text || '').split('|||');
              return { ...img, text: parts[0] || '', description: parts[1] || '' };
            });
          }
          this.logoFlag = true;
          this.ref.detectChanges();
          setTimeout(() => {
            $('.carousel').carousel({
              interval: 3000,
              ride: 'carousel'
            });
          }, 500);
        }, err => {
          this.logoFlag = false;
          this.util.redirect('auth/login/staff')
        })
    }
  }
  /**
   * Load CSS for this specific page only, and destroy when navigate away
   * @param styleUrl
   */
  private loadCSS(styleUrl: string) {
    return new Promise((resolve, reject) => {
      const styleElement = document.createElement('link');
      styleElement.href = styleUrl;
      styleElement.type = 'text/css';
      styleElement.rel = 'stylesheet';
      styleElement.onload = resolve;
      this.render.appendChild(this.el.nativeElement, styleElement);
    });
  }
  setWhiteLabelling() {
    setTimeout(() => {
      if (localStorage.getItem('copyrightName')) {
        this.copyrightName = localStorage.getItem('copyrightName')
      }
      if (localStorage.getItem('displayLogo')) {
        this.displayLogo = localStorage.getItem('displayLogo')
      }else{
        this.displayLogo = './../../../../assets/images/OD-campus-logo.png'
      }
      // if(localStorage.getItem('titleName')){
      //   this.titleName = localStorage.getItem('titleName')
      // }
      if (localStorage.getItem('displayDescription')) {
        this.displayDescription = localStorage.getItem('displayDescription')
      }
      if (localStorage.getItem('displayName')) {
        this.displayName = localStorage.getItem('displayName')
      }
      if (localStorage.getItem('privacyPolicyUrl')) {
        this.privacyPolicyFlag = true;
        this.privacyPolicyUrl = localStorage.getItem('privacyPolicyUrl')
      } else {
        this.privacyPolicyFlag = false;
      }
      if (localStorage.getItem('tncUrl')) {
        this.tncFlag = true;
        this.tncUrl = localStorage.getItem('tncUrl')
      } else {
        this.tncFlag = false;
      }
      if (localStorage.getItem('disclaimerUrl')) {
        this.disclaimerFlag = true;
        this.disclaimerUrl = localStorage.getItem('disclaimerUrl')
      } else {
        this.disclaimerFlag = false;
      }
      if (localStorage.getItem('loginRedirect') && localStorage.getItem('loginRedirect') == 'student') {
        let qac = this.route.snapshot.paramMap.get('qac');
        if (qac) {
          this.util.redirect('auth/' + qac)
        } else {
          this.util.redirect('auth/login')
        }
        return;
      }
      this.ref.detectChanges();
    }, 1000);

  }
  redirectToURL(url) {
    window.open(url, "_blank");
  }
  redirect(route) {
    this.util.redirect(route);
  }
  openEntityList() {
    this.api.openEntityList()
      .subscribe(res => {
      },
        err => {
        })
  }
  validateForm() {
    this.loginForm = this.fb.group({
      mobile: ['', Validators.compose([
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10),
        Validators.pattern("[0-9{10,10} \'\-]+$")

      ]),
      ],
      password: ['', Validators.compose([
        // Validators.required,
        // Validators.minLength(2),
        // Validators.maxLength(100),
      ])
      ],
      otp: ['', Validators.compose([
        // Validators.required,
        // Validators.minLength(6),
        // Validators.maxLength(6),
      ])
      ],
    })
  }
  selectOTPLogin() {
    this.otpFlag = true;
    this.otpInputFlag = false;
    this.HarError = false;
    this.errorMessage = '';
    this.authNoticeService.setNotice(null);
    this.loginForm.controls.password.clearValidators();
    this.loginForm.controls.password.updateValueAndValidity();
  }
  selectNormalLogin() {
    this.otpFlag = false;
    this.loginForm.controls.otp.clearValidators();
    this.loginForm.controls.otp.updateValueAndValidity();
    this.loginForm.controls.password.setValidators([Validators.required, Validators.minLength(2), Validators.maxLength(100)]);
    this.loginForm.controls.password.updateValueAndValidity();
  }
  getOTP() {
    const controls = this.loginForm.controls;

    if (this.loginForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;
    let mobile = this.loginForm.controls.mobile.value;
    this.api.sendOtp(mobile)
      .subscribe(res => {
        this.otpInputFlag = true;
        this.loading = false;
        this.util.alertMessage('OTP', 'Sent');
        this.loginForm.controls.otp.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(6)]);
        this.loginForm.controls.otp.updateValueAndValidity();
        this.ref.detectChanges();
        // this.resendOTPTimer();
      },
        err => {
          console.log(err);
          this.loading = false;
        })
  }
  toggleButtonOfOtp(value) {
    this.showCallButton = !this.showCallButton
    this.resendOTP(value)
  }
  resendOTP(value) {
    this.loginForm.controls.otp.clearValidators();
    this.loginForm.controls.otp.updateValueAndValidity();
    const controls = this.loginForm.controls;

    if (this.loginForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;
    let mobile = this.loginForm.controls.mobile.value;
    this.api.resendOtp(mobile, value)
      .subscribe(res => {
        this.loading = false;
        this.otpInputFlag = true;
        this.util.alertMessage('OTP', 'Resent');
        this.loading = false;
        this.loginForm.controls.otp.setValidators([Validators.required, Validators.minLength(6), Validators.maxLength(6)]);
        this.loginForm.controls.otp.updateValueAndValidity();

        this.ref.detectChanges()
        // this.resendOTPTimer();
      },
        err => {
          console.log(err);
          this.loading = false;
          this.ref.detectChanges()
        })
  }
  // resendOTPTimer(){

  //   setInterval(this.delayTimer), 1000);

  // }
  // delayTimer(){
  //   for(let i = 30; i>=0; i--){
  //     // setTimeout(() => {
  //     //   this.timerValue = i;
  //     //   this.ref.detectChanges();
  //     // }, 1000);
  //   }
  // }
  submitOTP() {
    const controls = this.loginForm.controls;

    if (this.loginForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;


    let mobile = this.loginForm.controls.mobile.value;
    let otp = this.loginForm.controls.otp.value;
    let source = 'erp'
    this.api.verifyOtp(mobile, otp, source)
      .subscribe(
        res => {
          localStorage.setItem('token', res.token)
          localStorage.setItem('name', res.name);
          localStorage.setItem('userType', res.userType)
          localStorage.setItem('mobile', res.mobile);
          localStorage.setItem('userId', res._id);
          localStorage.setItem('permissions', res.permissions)
          localStorage.setItem('primaryColour', '#1ca9c9');
          localStorage.setItem('secondaryColour', '#ffffff');
          this.menuAside.loadMenu();
          this.menuHorizontal.loadMenu();
          switch (res.userType) {
            case "od1":
              window.location.href = this.browserDomain + '/dashboard';
              break;
            case "od2":
            case "od3":
              if (res.entityGroup) {
                localStorage.setItem('entityGroup', JSON.stringify(res.entityGroup))
              }
              else {
                localStorage.setItem('entityGroup', JSON.stringify([]))
              }
              localStorage.setItem('entityId', res.entity._id);
              localStorage.setItem('homeEntityId', res.entity._id);
              localStorage.setItem('qac', res.entity.qac);
              if (res.employee) {
                localStorage.setItem('employee', res.employee);
              }
              if (res.myOperatorId) {
                localStorage.setItem('myOperatorId', res.myOperatorId);
              }
              if (res.employeeId) {
                localStorage.setItem('employeeId', res.employeeId);
              }
              if (res.employeeType) {
                localStorage.setItem('employeeType', res.employeeType);
              }
              if (res.admissionSource) {
                localStorage.setItem('admissionSource', JSON.stringify(res.admissionSource));
              }
              localStorage.setItem('entityData', JSON.stringify(res.entity));
              localStorage.setItem('logo', res.entity.logo);
              localStorage.setItem('staticQR', res.entity.staticQR);
              localStorage.setItem('tourStage', res.entity.tourStage)
              localStorage.setItem('welcomeTour', res.entity.welcomeTour)
              localStorage.setItem('entityPreferences', JSON.stringify(res.entity.entityPreferences))
              if (res.userPreferences) {
                localStorage.setItem('userPreferences', JSON.stringify(res.userPreferences));
              }
              if (res.entity.entityPreferences && res.entity.entityPreferences.primaryColour) {
                localStorage.setItem('primaryColour', res.entity.entityPreferences.primaryColour);
                if (res.entity.entityPreferences.primaryColour == '#ffffff' || res.entity.entityPreferences.primaryColour == '#fff') {
                  localStorage.setItem('primaryColour', '#1ca9c9');
                }
              }
              if (res.entity.entityPreferences && res.entity.entityPreferences.secondaryColour) {
                localStorage.setItem('secondaryColour', res.entity.entityPreferences.secondaryColour);
              }
              if (res.entity.communicationSetup) {
                localStorage.setItem('communicationSetup', JSON.stringify(res.entity.communicationSetup))
              }
              // localStorage.setItem('entityName', res.entity.name)
              localStorage.setItem('entityName', res.entity.displayName)
              localStorage.setItem('entityType', res.entity.entityType)
              if (!res.entity.activeSession) {
                this.util.alertNotificationMessage('Please Activate A Session First');
                // this.router.navigate(['/academicSession'])
                window.location.href = this.browserDomain + '/schoolSetup/academicSession';
                // this.util.redirect('/academicSession')
                // return
              } else {
                // if(res.userPreferences && res.userPreferences.session){
                //   localStorage.setItem('session', res.userPreferences.session);
                // }else{
                //   localStorage.setItem('session', res.entity.activeSession.name);
                // }
                localStorage.setItem('superSession', res.entity.activeSession.superSession);
                localStorage.setItem('sessionStartDate', res.entity.activeSession.startDate);
                localStorage.setItem('sessionEndDate', res.entity.activeSession.endDate);
                localStorage.setItem('session', res.entity.activeSession.name)
                if (res.userPreferences && res.userPreferences.session) {
                  this.api.fetchSession(res.entity._id, res.userPreferences.session)
                    .subscribe(res => {
                      localStorage.setItem('session', res.name);
                      localStorage.setItem('superSession', res.superSession);
                      localStorage.setItem('sessionStartDate', res.startDate);
                      localStorage.setItem('sessionEndDate', res.endDate);
                      window.location.href = this.browserDomain + '/entity/dashboard';
                    }, err => {
                      this.util.confirmAlert('Preferred session not found in this institute, switched to active session').subscribe((sure: boolean) => {
                        if (sure) {
                          window.location.href = this.browserDomain + '/entity/dashboard';
                        } else {
                          this.loading = false
                          this.logout()
                          this.ref.detectChanges()
                        }
                      })
                    })
                } else {
                  window.location.href = this.browserDomain + '/entity/dashboard';
                }
                // this.util.redirect('/entityDashboard')
              }
              break;
            default: {
              this.util.redirect('/auth/register')
            }
          }
          this.loading = false;

        },
        err => {
          this.loading = false;
          this.errorMessage = err.error.message;
          this.authNoticeService.setNotice(this.errorMessage, 'danger');
          this.HarError = true;
          this.clearErrorAfterDelay();
        }
      )

  }
  submit() {
    const controls = this.loginForm.controls;

    if (this.loginForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    this.loading = true;

    const authData = {
      mobile: this.loginForm.controls.mobile.value,
      password: this.loginForm.controls.password.value,
    }
    this.api.login(authData)
      .subscribe(
        res => {
          localStorage.setItem('token', res.token)
          localStorage.setItem('name', res.name);
          localStorage.setItem('userType', res.userType)
          localStorage.setItem('mobile', res.mobile);
          localStorage.setItem('userId', res._id);
          localStorage.setItem('permissions', res.permissions)
          localStorage.setItem('primaryColour', '#1ca9c9');
          localStorage.setItem('secondaryColour', '#ffffff');
          if (res.entity)
            localStorage.setItem('contactEmail', res.entity.contactEmail)
          this.menuAside.loadMenu();
          this.menuHorizontal.loadMenu();
          switch (res.userType) {
            case "od1":
              window.location.href = this.browserDomain + '/dashboard';
              break;
            case "od2":
            case "od3":
              if (res.entityGroup) {
                localStorage.setItem('entityGroup', JSON.stringify(res.entityGroup))
              }
              else {
                localStorage.setItem('entityGroup', JSON.stringify([]))
              }
              localStorage.setItem('entityId', res.entity._id);
              localStorage.setItem('homeEntityId', res.entity._id);
              localStorage.setItem('qac', res.entity.qac);
              if (res.employee) {
                localStorage.setItem('employee', res.employee);
              }
              if (res.myOperatorId) {
                localStorage.setItem('myOperatorId', res.myOperatorId);
              }
              if (res.admissionSource) {
                localStorage.setItem('admissionSource', JSON.stringify(res.admissionSource));
              }
              if (res.employeeId) {
                localStorage.setItem('employeeId', res.employeeId);
              }
              if (res.employeeType) {
                localStorage.setItem('employeeType', res.employeeType);
              }
              localStorage.setItem('entityData', JSON.stringify(res.entity));
              localStorage.setItem('logo', res.entity.logo);
              localStorage.setItem('tourStage', res.entity.tourStage)
              localStorage.setItem('welcomeTour', res.entity.welcomeTour)
              localStorage.setItem('staticQR', res.entity.staticQR);
              localStorage.setItem('entityPreferences', JSON.stringify(res.entity.entityPreferences))
              if (res.userPreferences) {
                localStorage.setItem('userPreferences', JSON.stringify(res.userPreferences));
              }
              if (res.entity.entityPreferences && res.entity.entityPreferences.primaryColour) {
                localStorage.setItem('primaryColour', res.entity.entityPreferences.primaryColour);
                if (res.entity.entityPreferences.primaryColour == '#ffffff' || res.entity.entityPreferences.primaryColour == '#fff') {
                  localStorage.setItem('primaryColour', '#1ca9c9');
                }
              }
              if (res.entity.entityPreferences && res.entity.entityPreferences.secondaryColour) {
                localStorage.setItem('secondaryColour', res.entity.entityPreferences.secondaryColour);
              }
              if (res.entity.communicationSetup) {
                localStorage.setItem('communicationSetup', JSON.stringify(res.entity.communicationSetup))
              }
              // localStorage.setItem('entityName', res.entity.name)
              localStorage.setItem('entityName', res.entity.displayName)
              localStorage.setItem('entityType', res.entity.entityType)
              if (!res.entity.activeSession) {
                this.util.alertNotificationMessage('Please Activate A Session First');
                // this.router.navigate(['/academicSession'])
                window.location.href = this.browserDomain + '/schoolSetup/academicSession';
                // this.util.redirect('/academicSession')
                // return
              } else {
                // localStorage.setItem('session', res.entity.activeSession.name);
                // localStorage.setItem('session', res.userPreferences.session);
                localStorage.setItem('session', res.entity.activeSession.name);
                localStorage.setItem('superSession', res.entity.activeSession.superSession);
                localStorage.setItem('sessionStartDate', res.entity.activeSession.startDate);
                localStorage.setItem('sessionEndDate', res.entity.activeSession.endDate);
                if (res.userPreferences && res.userPreferences.session) {
                  this.api.fetchSession(res.entity._id, res.userPreferences.session)
                    .subscribe(res => {
                      localStorage.setItem('session', res.name);
                      localStorage.setItem('superSession', res.superSession);
                      localStorage.setItem('sessionStartDate', res.startDate);
                      localStorage.setItem('sessionEndDate', res.endDate);
                      window.location.href = this.browserDomain + '/entity/dashboard';
                    }, err => {
                      this.util.confirmAlert('Preferred session not found in this institute, switched to active session').subscribe((sure: boolean) => {
                        if (sure) {
                          window.location.href = this.browserDomain + '/entity/dashboard';
                        } else {
                          this.loading = false
                          this.logout()
                          this.ref.detectChanges()
                        }
                      })


                    })
                } else {
                  window.location.href = this.browserDomain + '/entity/dashboard';
                }


                // this.util.redirect('/entityDashboard')
              }
              break;
            default: {
              this.util.redirect('/auth/register')
            }
          }
          this.loading = false;

        },
        err => {
          this.loading = false;
          this.errorMessage = err.error.message;
          this.authNoticeService.setNotice(this.errorMessage, 'danger');
          this.HarError = true;
          this.clearErrorAfterDelay();
        }
      )

  }
  logout() {
    const hasXToken = !!this.util.getCookie('x-token');
    const hasNoRedirect = !!this.util.getCookie('noRedirect');
    localStorage.removeItem('token');
    localStorage.removeItem('isExternalLogin');
    localStorage.removeItem('name')
    localStorage.removeItem('userType');
    localStorage.removeItem('session');
    localStorage.removeItem('mobile');
    localStorage.removeItem('sessionEndDate');
    localStorage.removeItem('sessionStartDate');
    localStorage.removeItem('entityType');
    localStorage.removeItem('entityId');
    localStorage.removeItem('homeEntityId');
    localStorage.removeItem('entityData');
    localStorage.removeItem('logo')
    localStorage.removeItem('entityName')
    localStorage.removeItem('primaryColour')
    localStorage.removeItem('entityGroup')
    localStorage.removeItem('permissions')
    localStorage.removeItem('secondaryColour')
    localStorage.removeItem('entityPreferences')
    localStorage.removeItem('userPreferences')
    localStorage.removeItem('qac')
    localStorage.removeItem('employee')
    localStorage.removeItem('employeeId')
    localStorage.removeItem('employeeType')
    localStorage.removeItem('layoutConfig');
    localStorage.removeItem('language');
    localStorage.removeItem('activeSessionStartDate');
    localStorage.removeItem('status');
    localStorage.removeItem('superSession');
    localStorage.removeItem('communicationSetup');
    localStorage.removeItem('tourStage')
    localStorage.removeItem('welcomeTour')
    localStorage.removeItem('admissionSource')
    localStorage.removeItem('courseByTeacherData')
    localStorage.removeItem('courseByTeacherDataDateWise');
    this.util.removeCookie('x-token');
    this.util.removeCookie('noRedirect');
    localStorage.removeItem('estimatedCollections');
		localStorage.removeItem('estimatedCollectionsDate');
    // localStorage.clear();
    if (hasXToken && !hasNoRedirect) {
      window.location.href = 'https://qa.extramarksforte.com/logout';
    }


  }
  getBannerTitle(index: number): string {
    const banner = this.entity.bannerImages && this.entity.bannerImages[index];
    if (banner && typeof banner === 'object' && banner.text) {
      return banner.text;
    }
    switch (index) {
      case 0:
        return `Welcome to <br>${this.entity.displayName || ''}`;
      case 1:
        return `Effortlessly Capture Student and <br> Employee Attendance Data`;
      case 2:
        return `Unlock the Power of Examination <br> Analysis and Library Management`;
      case 3:
        return `New Feature <br> Description Goes Here`;
      default:
        return '';
    }
  }

  getBannerSubtitle(index: number): string {
    const banner = this.entity.bannerImages && this.entity.bannerImages[index];
    if (banner && typeof banner === 'object') {
      return banner.description || '';
    }
    if (index === 0) {
      return 'Empowering academic excellence through digital systems';
    }
    return '';
  }

  clearErrorAfterDelay() {
    setTimeout(() => {
      this.HarError = false;
      this.errorMessage = '';
      this.authNoticeService.setNotice(null);
      this.ref.detectChanges();
    }, 5000);
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.loginForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

}
